import { render } from "./SubProjectEditPopup.vue?vue&type=template&id=8ddd5f74&scoped=true"
import script from "./SubProjectEditPopup.vue?vue&type=script&lang=js"
export * from "./SubProjectEditPopup.vue?vue&type=script&lang=js"

import "./SubProjectEditPopup.vue?vue&type=style&index=0&id=8ddd5f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddd5f74"]])

export default __exports__